import { store } from "../store";
import { alertDialogGoToBeginning } from "../actions";
// import { translator } from "./i18n";
import ky from "ky";

export default async (_request, _options, response) => {
  const json = await response.json();

  if (json == null || (Array.isArray(json) && json.length === 0)) {
    store.dispatch(alertDialogGoToBeginning(true));
    // store.dispatch(alertDialog(translator()._("W_ERROR")));

    const {
      idc,
      widgetType,
      practitioner,
      appointment,
      userId
    } = store.getState().returnedValue;
    const baseURL = store.getState().configuration.baseURL;

    const url = new URL(response.url || _request.url);
    const service = url.pathname
      .replace(/^\//, "") // remove first /
      .replace(/^ajax\//, "") // remove ajax/
      .replace(/\.php/, ""); // remove .php

    const searchParams = {
      guid: "guid",
      type: widgetType,
      bdebug: 1,
      url: baseURL,
      service: service
    };
    if (practitioner) {
      searchParams["idpraticien"] = practitioner;
    }
    if (appointment) {
      searchParams["idrdv"] = appointment;
    }
    if (userId) {
      searchParams["userId"] = userId;
    }

    await ky.post(
      `https://central.alaxione.fr/api_synchro/central/push_alert/${idc}`,
      {
        searchParams
      }
    );
  }
};
